import React from 'react'
import Img from 'gatsby-image'
import { fragThing } from '../utils/fragments'
import { mapThings, mapMetaData } from '../utils/mapper'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Link from 'gatsby-link'

import TextGradient from '../components/gradient'
import MetaData from '../components/metadata'
import Banner from '../components/banner'
import Quote from '../components/quote'
import Footer from '../components/footer'

import styles from '../styles/site'

const ThingsPage = props => {
  const { classes } = props
  const metadata = mapMetaData(props.data.things)
  const things = mapThings(props.data.things)
  return (
    <div>
      <MetaData data={metadata} />
      <Banner uid="contact" title={things.title} subtitle={things.subtitle} />
      <Things data={things} />
      <Footer policies={props.data.policies.edges}/>
    </div>
  )
}

const Things = withStyles(styles)(props => {
  const { classes, data } = props
  return (
    <div className={classes.channels}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="display1" className={classes.channelTitle}>
                <TextGradient
                  text={data.title.text}
                  fromColor="#79BC62"
                  toColor="#0087FC"
                  direction="left"
                />
              </Typography>
              <Typography>{data.intro.text}</Typography>
              <div className={classes.thingsItemsList}>
                {data.list.map((thing, index) => {
                  return <Thing key={index} data={thing} index={index} classes={classes} />
                })}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

const Thing = props => {
  const { data, index, classes } = props
  return (
    <Paper className={classes.thingsItem} elevation={0}>

        <Grid container spacing={16}>
          <Grid item xs={12} sm={4} style={{
              display: 'flex', alignItems: 'flex-start'
            }}>
            <Img sizes={data.logo.sizes} className={classes.thingsItemLogo} />
          </Grid>
          <Grid item xs={12} sm={8}>
            {/* <div>
              <Typography variant="title" className={classes.thingsItemTitle}>
                {data.title.text}
              </Typography>
            </div> */}
            <div>
              <Typography className={classes.thingsItemText}>
                {`${data.intro.text.substr(0, 150)} ...`}
              </Typography>
            </div>
            <div>
              <Button
                variant={'outlined'}
                component={Link}
                to={`/things/${data.uid}`}
                size="small"
                className={classes.thingsItemButton}
              >
                Find out more
              </Button>
            </div>
          </Grid>
        </Grid>


      {/* {index % 2 === 0 ? (
        <Grid container spacing={16}>
          <Grid item xs={12} sm={4}>
            <Img sizes={data.logo.sizes} className={classes.thingsItemLogo} />
          </Grid>
          <Grid item xs={12} sm={8}>
            <div>
              <Typography variant="title" className={classes.thingsItemTitle}>
                {data.title.text}
              </Typography>
            </div>
            <div>
              <Typography className={classes.thingsItemText}>
                {`${data.intro.text.substr(0, 150)} ...`}
              </Typography>
            </div>
            <div>
              <Button
                variant={'outlined'}
                component={Link}
                to={`/things/${data.uid}`}
                size="small"
                className={classes.thingsItemButton}
              >
                Find out more
              </Button>
            </div>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={16}>
          <Grid item xs={12} sm={8}>
            <div>
              <Typography variant="title" className={classes.thingsItemTitle}>
                {data.title.text}
              </Typography>
            </div>
            <div>
              <Typography className={classes.thingsItemText}>
                {`${data.intro.text.substr(0, 150)} ...`}
              </Typography>
            </div>
            <div>
              <Button
                variant={'outlined'}
                component={Link}
                to={`/things/${data.uid}`}
                size="small"
                className={classes.thingsItemButton}
              >
                Find out more
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Img sizes={data.logo.sizes} className={classes.thingsItemLogo} />
          </Grid>
        </Grid>
      )} */}
    </Paper>
  )
}

export default withStyles(styles)(ThingsPage)

export const query = graphql`
  query thingsQuery {
    things: prismicCtThings {
      data {
        title {
          html
          text
        }
        subtitle {
          html
          text
        }
        intro {
          html
          text
        }
        body {
          items {
            thing {
              document {
                ...thing
              }
            }
          }
        }
      }
    }

    policies: allPrismicCtDoc {
      edges {
      node {
        uid
        data {
            title {
              
              text
            }
            
            
          }
      }
      }
      }
  }
`



// WEBPACK FOOTER //
// ./src/pages/things.js